import TICKETS_API from 'api/tickets/v1'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { parse } from 'date-fns'
import { FETCH, SET_LOADING, SET_TICKETS } from 'modules/Tickets/types'

function* fetchTickets({ payload }) {
  const { pagination } = yield select((state) => state['tickets'])

  try {
    yield put({ type: SET_LOADING, payload: { loading: true } })

    const { response, error } = yield call(TICKETS_API.fetchTickets, {
      ...payload,
    })

    if (error) {
      throw error
    }

    const {
      data,
      pagination: { total },
    } = response

    yield put({
      type: SET_TICKETS,
      payload: {
        data: data.map((i) => ({
          ...i,
          //Увы надо приводить данные так на формат ответа мы не влияем
          date: parse(i.updated_at, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date()).getTime() / 1000,
        })),
        pagination: {
          ...pagination,
          total,
        },
        loaded: true,
        loadFailed: false,
      },
    })
  } catch (error) {
    yield put({
      type: SET_TICKETS,
      payload: {
        data: [],
        loaded: true,
        loadFailed: true,
      },
    })
    console.logXHR(error)
  } finally {
    yield put({ type: SET_LOADING, payload: { loading: false } })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH, fetchTickets)
}
